import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ message, status }) => {
    return (
        <div className="overlay-bg">
            <div className="overlay-card">
                <svg className="clock-svg" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="44" stroke="#5B7BF8" strokeWidth="5" fill="none"/>
                    <line className="hour-hand" x1="50" y1="50" x2="50" y2="22" stroke="#5B7BF8" strokeWidth="5" strokeLinecap="round"/>
                    <line className="minute-hand" x1="50" y1="50" x2="72" y2="62" stroke="#5B7BF8" strokeWidth="3.5" strokeLinecap="round"/>
                    <circle cx="50" cy="50" r="4" fill="#5B7BF8"/>
                </svg>
                <p className={`overlay-message ${status || ''}`}>{message}</p>
            </div>
        </div>
    );
};

export default LoadingOverlay;